import Button from "Components/button";
import { themeVariables } from "Components/theme";
import React, { memo, useMemo } from "react";
import locale from "./cancelPanel.locale";
import Styled from "./cancelPanel.styled";
const messageStyle = {
    minHeight: themeVariables["line-height-computed"]
};
function CancelPanel(props) {
    const containerStyle = useMemo(() => ({
        zIndex: props.zIndex
    }), [props.zIndex]);
    return (React.createElement(Styled.Container, { style: containerStyle, className: "position-absolute d-grid text-center v-center-items h-center-items align-content-center" },
        React.createElement("h3", { className: "font-bold" }, locale.LOADiNG_TITLE),
        React.createElement("div", { className: "text-muted mb-1_25" }, locale.LOADING_DESCRIPTION),
        React.createElement(Styled.Loader, null),
        React.createElement("span", { style: messageStyle, className: "text-muted font-small text-overflow-ellipsis pt-0_25", id: props.messageBoxId }),
        React.createElement(Button, { className: "mt-0_75", onClick: props.onCancel }, props.cancelText)));
}
export default memo(CancelPanel);
CancelPanel.defaultProps = {
    cancelText: locale.CANCEL
};
